import Handlebars from 'handlebars/runtime';

import { T18n } from '../utils/t18n';

// Just an example helper function for handlebars templates
export default function (itemId) {
  const translation = T18n._(itemId);
  return new Handlebars.SafeString(translation);
}
